export const GET_TOKEN_RECAPTCHA = 'app/recaptcha/get'